import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from 'src/shared/globals';
import { AuthGuard } from 'src/app/_guards/auth.guard';

@Injectable({
  providedIn: 'root'
})
export class SubmitPropertyService {
  url = `${this.global.apiUrl}Property/`;
  constructor(private httpService: HttpClient, private global: Globals, private authService: AuthGuard) {
  }

  public SubmitProperty(form: FormData): Observable<any> {
    if (this.authService.isLoggedIn()) {
      return this.httpService.post(this.url + 'SubmitPropertyDetails', form);
    } else {
      return this.httpService.post(this.url + 'SubmitPropertyAnonymous', form);
    }
  }

  public getPropertyDetails(): Observable<any> {
    return this.httpService.get(this.url + 'SubmitPropertyDetails');
  }

  public getLocationsByCityId(cityId: number): Observable<any> {
    return this.httpService.get(this.url + 'Locations?cityId=' + cityId);
  }

  public GetPropertyDetailsByID(PropertyId: number): Observable<any> {
    return this.httpService.get(this.url + 'GetPropertyDetailsByID?PropertyId=' + PropertyId);
  }
}
